module.exports = __webpack_public_path__ + "img/hakuna_p01_img01.ed2b4fa3.jpg";